import copy from './generated/copy.json';
import {
  archiveGoalDefinitions,
  archiveGoalTargets,
  defaultArchiveGoalDrafts,
} from './generated/archiveGoals';
export const archiveTranslate =
  (locale) =>
  (key, params = {}) =>
    (copy[locale === 'en' ? 'en' : 'ko'][key] ?? key).replace(/\{\{(\w+)\}\}/g, (_, name) =>
      String(params[name] ?? ''),
    );
export const archiveKey = (id, period) => ['me', 'archive', id, period];
export const defaultArchivePeriod = (week, month) =>
  week?.goal.isConfigured && !month?.goal.isConfigured ? 'WEEK' : 'MONTH';
const count = (value) => Number.isInteger(value) && value >= 0;
export function archivePayload(response, requestedPeriod) {
  const data = response?.data?.data ?? response?.data;
  const periodType = data?.periodType ?? requestedPeriod;
  if (
    !data ||
    !['WEEK', 'MONTH'].includes(periodType) ||
    typeof data.period !== 'string' ||
    !/^\d{4}-\d{2}(-\d{2})?$/.test(data.period) ||
    !data.goal ||
    typeof data.goal.isConfigured !== 'boolean' ||
    !count(data.goal.reviewTarget) ||
    !data.progress ||
    !count(data.progress.writtenReviews) ||
    ['newArtists', 'activeDays'].some(
      (key) => data.progress[key] != null && !count(data.progress[key]),
    ) ||
    (data.goal.items != null &&
      (!Array.isArray(data.goal.items) ||
        !data.goal.items.every(
          (item) =>
            item &&
            ['LISTENED_ALBUMS', 'WRITTEN_REVIEWS', 'NEW_ARTISTS', 'ACTIVE_DAYS'].includes(
              item.type,
            ) &&
            count(item.target),
        )))
  )
    throw Error('Invalid archive response');
  const [year, month, day] = data.period.split('-').map(Number);
  if (
    month < 1 ||
    month > 12 ||
    (periodType === 'WEEK' &&
      (!day || day < 1 || new Date(year, month - 1, day).getMonth() !== month - 1))
  )
    throw Error('Invalid archive period');
  return { ...data, periodType };
}
export const goalCopy = (type) =>
  ({
    WRITTEN_REVIEWS: { label: 'writtenReviews', suffix: 'itemSuffix' },
    NEW_ARTISTS: { label: 'newArtists', suffix: 'personSuffix' },
    ACTIVE_DAYS: { label: 'activeDays', suffix: 'daySuffix' },
  })[type];
export function archivePeriodTitle(data, locale, t) {
  const [year, month, day] = data.period.split('-').map(Number);
  const monthLabel = new Intl.DateTimeFormat(locale === 'en' ? 'en-US' : 'ko-KR', {
    month: 'long',
  }).format(new Date(year, month - 1, 1));
  const ordinal =
    locale === 'en'
      ? String(Math.min(Math.ceil(day / 7), 5))
      : ['첫째', '둘째', '셋째', '넷째', '다섯째'][Math.min(Math.ceil(day / 7), 5) - 1];
  return t(data.periodType === 'WEEK' ? 'archive.weekRecord' : 'archive.monthRecord', {
    month: monthLabel,
    ordinal,
  });
}
export const goalDrafts = (data, period) => {
  const values = data ? archiveGoalTargets(data) : defaultArchiveGoalDrafts(period);
  return Object.fromEntries(archiveGoalDefinitions.map((x) => [x.type, String(values[x.type])]));
};
export function goalPayload(drafts) {
  const items = archiveGoalDefinitions.map((x) => ({
    type: x.type,
    target: Number.parseInt(drafts[x.type], 10) || 0,
  }));
  if (items.every((x) => x.target === 0)) return { error: 'archive.editor.oneRequired' };
  if (items.some((x) => x.target < 0 || x.target > 100))
    return { error: 'archive.editor.maxValue' };
  return {
    payload: {
      albumTarget: 0,
      reviewTarget: items.find((x) => x.type === 'WRITTEN_REVIEWS').target,
      items,
    },
  };
}
